import React from 'react';
import { Trans } from '@lingui/macro';

import VisibleStatusBar from '@src/components/VisibleStatusBar';

import { Container, Title } from './styled';
import { Props } from './types';

const Screen: React.FC<Props> = () => {
  return (
    <>
      <VisibleStatusBar />
      <Container>
        <Title>
          <Trans>Not implemented</Trans>
        </Title>
      </Container>
    </>
  );
};

Screen.displayName = 'NewPost';

export default React.memo(Screen);
